"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlogIndex = void 0;
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const BlogDirectory_1 = require("./BlogDirectory");
const BlogIndex = () => {
    return (React.createElement("div", { className: "blog-index" },
        React.createElement("h1", null, "Blog Index:"),
        BlogDirectory_1.BLOG_POSTS.map((blogItem) => {
            return (React.createElement(React.Fragment, null,
                React.createElement(react_router_dom_1.Link, { to: (0, BlogDirectory_1.urlForBlogItem)(blogItem) },
                    blogItem.publishDate.getFullYear(),
                    "-",
                    blogItem.publishDate.getMonth() + 1,
                    " : ",
                    blogItem.title),
                React.createElement("br", null)));
        })));
};
exports.BlogIndex = BlogIndex;
exports.default = exports.BlogIndex;
